import {
  AlignmentEnum,
  BackgroundColorEnum,
  YoutubeVideoComponentData,
} from '@boels/models';

export const YoutubeVideoComponentDataMock: YoutubeVideoComponentData = {
  videoId: 'FsgsuaGbaLU',
  imageAlignment: AlignmentEnum.RIGHT,
  backgroundColor: BackgroundColorEnum.GREY,
  bodyText:
    'Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro. Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis. Quo consequuntur enim in aperiam eveniet in adipisci voluptatem eum dolorum tempore At magnam tempore 33 voluptas dolor.',
  removeBottomSpacing: false,
  title: 'Youtube Video Editor',
  removeGradient: false,
};

export const YoutubeVideoLeftComponentDataMock: YoutubeVideoComponentData = {
  videoId: 'FsgsuaGbaLU',
  imageAlignment: AlignmentEnum.LEFT,
  backgroundColor: BackgroundColorEnum.WHITE,
  bodyText:
    'Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro. Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis. Quo consequuntur enim in aperiam eveniet in adipisci voluptatem eum dolorum tempore At magnam tempore 33 voluptas dolor.',
  removeBottomSpacing: false,
  title: 'Youtube Video Editor',
  removeGradient: false,
};

export const YoutubeVideoCenterComponentDataMock: YoutubeVideoComponentData = {
  videoId: 'FsgsuaGbaLU',
  imageAlignment: AlignmentEnum.CENTER,
  backgroundColor: BackgroundColorEnum.WHITE,
  bodyText:
    'Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro. Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis. Quo consequuntur enim in aperiam eveniet in adipisci voluptatem eum dolorum tempore At magnam tempore 33 voluptas dolor.',
  removeBottomSpacing: false,
  title: 'Youtube Video Editor',
  removeGradient: false,
};
